import React from 'react'
import HeaderFour from '../header/HeaderFour';
import BannerSix from '../elements/BannerSix';
import AboutOne from '../elements/AboutOne';
import ServiceFIve from '../elements/ServiceFIve';
import PortfolioFour from '../elements/PortfolioFour';
import WorkingProcess from '../elements/WorkingProcess';
import TestimonialsBrand from '../elements/TestimonialsBrand';
import Contact from '../elements/Contact';
import Team from '../elements/Team';
import BlogFive from '../elements/BlogFive';
import FooterSix from '../footer/FooterSix';






function HomeSix() {
    return (
        <div>
            <div className="index-Six">
                <HeaderFour/>
                <main>
                    <BannerSix/>
                    <AboutOne/>
                    <ServiceFIve/>
                    <PortfolioFour/>
                    <WorkingProcess/>
                    <TestimonialsBrand/>
                    <Contact/>
                    <Team/>
                    <BlogFive/>
                    <FooterSix/>
                </main>
            </div>
        </div>
    )
}

export default HomeSix